<template>
  <div class="login-container">
    <div class="login-card">
      <h2>Iniciar Sesión</h2>
      
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="username">Usuario</label>
          <input 
            id="username" 
            v-model="username" 
            type="text" 
            required
            autocomplete="username"
          />
        </div>
        
        <div class="form-group">
          <label for="password">Contraseña</label>
          <input 
            id="password" 
            v-model="password" 
            type="password" 
            required
            autocomplete="current-password"
          />
        </div>
        
        <button 
          type="submit" 
          :disabled="loading"
          class="btn-primary"
        >
          {{ loading ? 'Iniciando...' : 'Iniciar Sesión' }}
        </button>
        
        <div class="register-link">
          ¿No tienes cuenta? <router-link to="/register">Regístrate</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'LoginView',
  setup() {
    const store = useStore()
    const username = ref('')
    const password = ref('')
    
    const loading = computed(() => store.state.auth.loading)
    const error = computed(() => store.state.auth.error)
    
    const handleSubmit = async () => {
      await store.dispatch('auth/login', {
        username: username.value,
        password: password.value
      })
    }
    
    return {
      username,
      password,
      loading,
      error,
      handleSubmit
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  h2 {
    margin-bottom: 1.5rem;
    text-align: center;
    color: #333;
  }
}

.form-group {
  margin-bottom: 1rem;
  
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
  
  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    
    &:focus {
      outline: none;
      border-color: #4299e1;
    }
  }
}

.btn-primary {
  display: block;
  width: 100%;
  padding: 0.75rem;
  margin-top: 1.5rem;
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background-color: #3182ce;
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.register-link {
  margin-top: 1rem;
  text-align: center;
  
  a {
    color: #4299e1;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

.error-message {
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #fed7d7;
  color: #c53030;
  border-radius: 4px;
  font-size: 0.875rem;
}
</style>